/**
 * Mock client for the cross-source "Asuntos sin atender" inbox.
 * Mirrors the live `GET /api/unattended-inbox` contract with demo data.
 */

import type { UnattendedInboxResponse } from '@zunelo/shared';
import { emptyUnattendedInbox } from '@zunelo/shared';
import type { ApiEnvelope } from '../../domain/types';
import type { ClientConfig, IUnattendedInboxClient } from './types';
import { simulateNetwork, DEFAULT_CONFIG } from './mockClientUtils';

export class MockUnattendedInboxClient implements IUnattendedInboxClient {
  private config: ClientConfig;

  constructor(config: ClientConfig = DEFAULT_CONFIG) {
    this.config = config;
  }

  async getUnattendedInbox(_options?: { fresh?: boolean }): Promise<ApiEnvelope<UnattendedInboxResponse>> {
    return simulateNetwork(() => {
      const inbox = emptyUnattendedInbox();
      return inbox;
    }, this.config);
  }
}